import { z } from 'zod'

export const SUPPORT_MCP_TRANSPORT_CONTRACT_VERSION = '1.0.0' as const

export const supportMcpJsonRpcRequestSchema = z.object({
  jsonrpc: z.literal('2.0'),
  id: z.union([z.string(), z.number(), z.null()]),
  method: z.string().min(1),
  params: z.record(z.unknown()).optional(),
}).passthrough()

export const supportMcpJsonRpcResponseSchema = z.object({
  jsonrpc: z.literal('2.0'),
  id: z.union([z.string(), z.number(), z.null()]),
}).passthrough()

export type SupportMcpJsonRpcRequest = z.infer<typeof supportMcpJsonRpcRequestSchema>
export type SupportMcpJsonRpcResponse = z.infer<typeof supportMcpJsonRpcResponseSchema>
